<template>
  <el-dialog
    class="comp-container"
    :visible.sync="visible"
    width="30%"
    top="30vh"
    custom-class="comfirm-remove-dialog"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="tips">
      你的账号在其他地方登录，超出了同时登录设备的数量限制,此设备被强制下线，请重新登录。
    </div>

    <div class="footer">
      <el-button @click="handleClickCancel">取消</el-button>
      <el-button type="primary" @click="handleReLogin"> 重新进入 </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import screenShare from "../mixins/screen-share";
import { closeWindow } from "@saas/components/src/utils/utils";

export default {
  mixins: [screenShare],

  data() {
    return {
      visible: false,
    };
  },
  computed: {
    ...mapState("live", ["liveService", "imService"]),
  },
  methods: {
    handleClickCancel() {
      this.visible = true;
      closeWindow();
    },
    handleReLogin() {
      location.reload();
    },
    open() {
      this.visible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-container ::v-deep {
  .comfirm-remove-dialog {
    width: 327px !important;
    background: #18181b;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
      0px 1px 3px 0px rgba(0, 0, 0, 0.1);
    border-radius: 12px 12px 12px 12px;
    border: 1px solid rgba(229, 231, 235, 0.04);
    padding: 16px;

    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
      font-size: 14px;
      color: #a1a1aa;

      text-align: center;
      .tips {
        max-width: 300px;
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .el-checkbox {
        margin-top: 8px;
        .el-checkbox__input.is-checked {
          .el-checkbox__inner {
            background: #165dff;
            border-color: #165dff;
          }
        }
        .el-checkbox__inner {
          border-color: #165dff !important;
          &:hover {
            border-color: #165dff;
          }
        }
        .el-checkbox__label {
          color: #a1a1aa;
        }
      }
      .footer {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-button {
          flex: 1;
          background: #165dff;
          border-radius: 12px 12px 12px 12px;
          border: none;
          font-weight: 500;
          font-size: 14px;
          color: #ecedee;
          &.el-button--primary {
            background: #165dff;
            &:hover {
              background: #165dff !important;
            }
            &:focus {
              background: #165dff !important;
            }
          }
          &.el-button--default {
            background: #3f3f46;
          }
        }
      }
    }
    .el-dialog__footer {
      display: none;
    }
  }
}
</style>
